import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService, LoggingService, UtilsJson, UtilsString } from '@pit/core';
import { EntityDataService } from '@pit/core-data';
import { IDtoUserRole, DtoUserRole } from '@pit/frontend-model';
import { IDtoUserRoleEntityDataService } from '../interfaces/dto.user.role.entity.data.service.interface';

@Injectable({
  providedIn: 'root'
})
export class DtoUserRoleEntityDataService extends EntityDataService<IDtoUserRole> implements IDtoUserRoleEntityDataService {

  constructor(http: HttpClient, configService: ConfigService, loggingService: LoggingService) {
    super(http, null, configService, loggingService);
  }

  protected override doGetApiUrl(): string {
    return UtilsString.stringFormat('/api/web/userroles');
  }

  protected override createEntityFromJson(json: any): IDtoUserRole {
    const result: IDtoUserRole = (UtilsJson.deserialize(json, DtoUserRole) as IDtoUserRole);
    if (result !== null) {
      result.setReferences();
    }

    return result;
  }

}
